import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useReduxStore from './useReduxStore';
import moment from 'moment-timezone';
import 'moment/locale/ar';
const useLanguage = () => {
  const { i18n, t } = useTranslation();
  const { selector: language } = useReduxStore("language");
  const currentLang = language?.lang || 'en';


  useEffect(() => {
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
  }, [currentLang, i18n]);


  useEffect(() => {
    document.documentElement.setAttribute('dir', i18n.dir(currentLang));
    moment.locale(currentLang);
  }, [currentLang, i18n]);

  return {
    currentLang,
    isEngLang: currentLang === 'en',
    isRTL: currentLang === 'ar',
    t,
  };
};

export default useLanguage;